import React, { createContext, useContext } from 'react';

// Context para dados SSR
const SSRContext = createContext();

// Hook para acessar dados SSR
export const useSSRData = () => {
  const context = useContext(SSRContext);
  if (!context) {
    // Fallback para dados do window (hidratação)
    return {
      initialData: window.__INITIAL_DATA__ || {},
      context: window.__USER_CONTEXT__ || {}
    };
  }
  return context;
};

// Wrapper para SSR
export const SSRWrapper = ({ children, initialData = {}, context = {} }) => {
  return (
    <SSRContext.Provider value={{ initialData, context }}>
      {children}
    </SSRContext.Provider>
  );
};

export default SSRWrapper;
